import { confirmation } from '@/utils/alert'

export default {
  doActive (covenant) {
    this.currentEntity = covenant

    const message = {
      label: null,
      title: null,
      message: null,
      cancel: null,
      ...this.getMessageActive
    }

    confirmation(confirm => {
      if (!confirm) {
        return
      }
      this.doActiveWithoutConfirmation(covenant)
    }, message.message, message.title, message.label, message.cancel)
  },
  doActiveWithoutConfirmation (covenant) {
    this.currentEntity = covenant

    if (!this.beforeDelete(covenant)) {
      return
    }

    this.$resource.delete(covenant.id + '?restore=true')
      .then(({data}) => {
        this.afterActive(covenant, data)
      })
  },
  afterActive (entity, itemActived) {
    const covenants = this.covenants
    const index = covenants.indexOf(entity)
    covenants[index]['active'] = itemActived.active

    this.covenants = [...covenants]
  },
  afterDelete (entity, itemDeleted) {
    const covenants = this.covenants
    const index = covenants.indexOf(entity)
    covenants[index]['active'] = itemDeleted.active

    this.covenants = [...covenants]
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/resources/methods.js